import { gql } from '@apollo/client'

export default gql`
  mutation CreateFavoriteFilter(
    $type: FavoriteSearchType!
    $name: String!
    $filterInput: String!
    $sortInput: String!
  ) {
    createNFTFavoriteFilter(
      favoriteSearchType: $type
      name: $name
      filterInput: $filterInput
      sortInput: $sortInput
    ) {
      ID
      name
      filterOption
      sortOption
    }
  }
`
